import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { DangerousHTMLSpan, ZeroState } from 'ecs-react-components/dist/index.es';
import { messages } from './SecureMessages.i18n';
import SecureMessageReply from './SecureMessageReply';
import * as ACTIONS from '../../redux/modules/secure-message/actions/creators';
import { patchArchivedThread } from '../../redux/modules/secure-message/secure-message-middleware';
import { formatDisplayName, findSelectedThread } from './SecureMessagesConfig';

class ThreadMessages extends Component {
  componentDidUpdate() {
    this.viewPane.scrollTop = 0;
  }

  onReplyButtonClick = () => {
    this.props.dispatch(ACTIONS.showSecureMessageReplyItem(true));
  }

  onArchiveClick = () => {
    const { patientId, timeZone, timeZoneOffset, language, dispatch, selectedThread } = this.props;
    const archiveStatus = this.props.filter === 'Current' ? 'Archived' : 'Current';
    const expectedMessage = archiveStatus === 'Archived' ?
      'securemessagethreadarchived' : 'securemessagethreadunarchived';
    // const threadId = archiveStatus === 'Archived' ?
    //   this.props.selectedThreadIndex : this.props.selectedArchivedThreadIndex;
    dispatch(patchArchivedThread(
      patientId,
      selectedThread.threadId,
      archiveStatus,
      expectedMessage,
      language,
      timeZone,
      timeZoneOffset))
      .then(
        () => {
          dispatch(ACTIONS.showSecureMessageReplyItem(false));
          dispatch(ACTIONS.secureMessageThreadSelected(null));
          dispatch(ACTIONS.secureMessageArchivedThreadSelected(null));
          dispatch(ACTIONS.secureMessageThreadClear());
          dispatch(ACTIONS.secureMessageListViewCompact(true));
        });
  }

  renderArchiveButton() {
    return (
       <button type="button" className="btn btn-link float-right"
         onClick={this.onArchiveClick}
       >
            <span className="fa-solid fa-archive me-lg-1" aria-hidden="true"></span>
            <span className="d-none d-md-inline">
            {
              this.props.filter === 'Current' ?
                (<FormattedMessage { ...messages.link.archive } />) :
                (<FormattedMessage { ...messages.link.unarchive } />)
            }
            </span>
       </button>
    );
  }

  renderReplyButton() {
    if (this.props.filter === 'Current') {
      return (
        <button type="button" className="btn btn-link float-right me-1" onClick={ this.onReplyButtonClick } >
            <span className="fa-solid fa-reply me-md-1" aria-hidden="true"></span>
            <span className="d-none d-md-inline">
              <FormattedMessage { ...messages.link.reply } />
            </span>
        </button>);
    }
    return null;
  }

  renderMessagesContentZeroStatePane() {
    return (
      <div className="col-lg-8 custom-list-wrapper d-none d-lg-block border border-secondary-subtle p-2" >
        <ZeroState
          zeroStateMessage={ <FormattedMessage { ...messages.page.initialStateMessage } /> }
          stateIconCss="fa-regular fa-envelope"
          ref={ (divViewPane) => { this.viewPane = divViewPane; } }
        />
      </div>
    );
  }

  render() {
    const {
      selectedThread,
    } = this.props;

    return (
      selectedThread ?
      <div className="col-lg-8 custom-list-wrapper message-thread border border-secondary-subtle p-2 overflow-y-scroll">
          <div ref={ (divViewPane) => { this.viewPane = divViewPane; } }>
            <div className="message-header">
              <DangerousHTMLSpan
                className="message-subject-line"
                qaTag="ThreadSubjectInMessagePane"
                html={ selectedThread.subjectText }
              />
              { this.renderArchiveButton() }
              { selectedThread.replyAllowed ? this.renderReplyButton() : null }
            </div>
              <ul className="list-group custom-list" data-qa-container="MsgsInThread">
              <SecureMessageReply />
                  {
                    this.props.messages.map((message, msgIndex) =>
                      (
                      <li className="list-group-item" key={ msgIndex }>
                        <div className="message-date-box">
                          {
                            message.displayDate.timePart ?
                              <div className="message-date">{ message.displayDate.timePart }</div> :
                              null
                          }
                          {
                            message.displayDate.datePart ?
                              <div className="message-date">{ message.displayDate.datePart }</div> :
                              null
                          }
                        </div>
                        <span className="primary-text bold">
                          {
                            formatDisplayName(
                              {
                                firstName: message.authorFirstName,
                                lastName: message.authorLastName,
                              },
                              {
                                firstName: message.proxyAuthorFirstName,
                                lastName: message.proxyAuthorLastName,
                              }
                            )
                          }
                        </span>
                        <DangerousHTMLSpan
                          className="secondary-text"
                          qaTag="messageContent"
                          html={ message.content }
                        />
                      </li>
                      ))
                  }
              </ul>
          </div>
      </div> :
        this.renderMessagesContentZeroStatePane()
    );
  }
}

ThreadMessages.propTypes = {
  messages: PropTypes.array,
  dispatch: PropTypes.func,
  filter: PropTypes.string,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  language: PropTypes.string,
  selectedThreadIndex: PropTypes.string,
  selectedArchivedThreadIndex: PropTypes.string,
  selectedThread: PropTypes.object,
  patientId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  filter: state.secureMessage.filter,
  patientId: state.profile.patient.patientId,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  language: state.language.languageCode,
  selectedThreadIndex: state.secureMessage.selectedThreadIndex,
  selectedArchivedThreadIndex: state.secureMessage.selectedArchivedThreadIndex,
  selectedThread: findSelectedThread(state.secureMessage),
});

export default connect(mapStateToProps)(ThreadMessages);